/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Discover_NavInputs */

const en_how_we_work_discover_nav = /** @type {(inputs: How_We_Work_Discover_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the starting point`)
};

const lv_how_we_work_discover_nav = /** @type {(inputs: How_We_Work_Discover_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrodam sākumpunktu`)
};

/**
* | output |
* | --- |
* | "Find the starting point" |
*
* @param {How_We_Work_Discover_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_discover_nav = /** @type {((inputs?: How_We_Work_Discover_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Discover_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_discover_nav(inputs)
	return en_how_we_work_discover_nav(inputs)
});